(ns ui.view.card.counterparty-diligence-screening.event
  (:require
   [re-frame.core :as rf]
   [ui.view.card.model :as common-model]
   [ui.view.card.event :as common-event]
   [ui.view.card.counterparty-diligence-screening.model :as model]
   [potpuri.core :as p]
   [frontend.controller.websocket.event :as ws]
   [frontend.global-events.toast :as toast]
   [common.localization :as loc]
   [common.schema.entities.counterparty-diligence.templates.registry :as cd-template-registry]))

(rf/reg-event-db
 ::toggle-expand-table-row
 [rf/trim-v]
 (fn [db [{:keys [card-state-path]} {:keys [row-id expanded?]}]]
   (let [prev-expanded (get-in db (model/expanded-table-rows-full-path card-state-path) #{})
         new-expanded (if expanded?
                        (conj prev-expanded row-id)
                        (disj prev-expanded row-id))]
     (assoc-in db (model/expanded-table-rows-full-path card-state-path) new-expanded))))

(rf/reg-event-db
 ::set-legal-entity-selected
 [rf/trim-v]
 (fn [db [{:keys [card-state-path] :as _ctx} {:keys [row-id selected? row-data]}]]
   (let [prev-selected (get-in db (model/selected-legal-entities-full-path card-state-path) #{})
         new-selected (if selected?
                        (conj prev-selected row-id)
                        (disj prev-selected row-id))

         new-selected-key-persons (if selected?
                                    (->> row-data
                                         :key-persons
                                         (mapv :_id)
                                         set)
                                    #{})]
     (-> db
         (assoc-in (model/selected-legal-entities-full-path card-state-path) new-selected)
         (assoc-in (conj (model/selected-legal-entity-key-persons-full-path card-state-path) row-id) new-selected-key-persons)))))

(rf/reg-event-db
 ::set-natural-person-selected
 [rf/trim-v]
 (fn [db [{:keys [card-state-path] :as _ctx} {:keys [row-id selected?]}]]
   (let [prev-selected (get-in db (model/selected-natural-persons-full-path card-state-path) #{})
         new-selected (if selected?
                        (conj prev-selected row-id)
                        (disj prev-selected row-id))]
     (assoc-in db (model/selected-natural-persons-full-path card-state-path) new-selected))))

(rf/reg-event-fx
 ::change-screening-status-success
 [rf/trim-v]
 (fn [_cofx [ctx _resp]]
   {:fx [[:dispatch [::common-event/fetch-card-data ctx]]]}))

(rf/reg-event-fx
 ::change-screening-status-error
 [rf/trim-v]
 (fn [_cofx [ctx resp]]
   (js/console.log "Change screening status error " resp)
   {:fx [[:dispatch [::common-event/fetch-card-data ctx]]
         [::toast/error (loc/tr :an-error-occurred)]]}))

(rf/reg-event-fx
 ::change-screening-status
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [entity-id card-state-path] :as ctx} screening-status]]
   (let [counterparty-diligence (common-model/get-entity db
                                                         card-state-path
                                                         entity-id)
         attribute (case (:entity/type counterparty-diligence)
                     :entity.type/person-counterparty-diligence
                     :person-counterparty-diligence/screening-status

                     :entity.type/company-counterparty-diligence
                     :company-counterparty-diligence/screening-status)
         new-entity (assoc counterparty-diligence attribute screening-status)]
     {:db (-> db
              (common-model/merge-entities card-state-path {entity-id new-entity}))
      ::ws/send {:id :entity/update-attribute
                 :body {:db/id entity-id
                        :attribute attribute
                        :value screening-status}
                 :on-success [::change-screening-status-success
                              (assoc ctx :new-screening-status screening-status)]
                 :on-error [::change-screening-status-error ctx]}})))

(rf/reg-event-db
 ::open-send-to-screening-modal
 [rf/trim-v]
 (fn [db [{:keys [card-state-path]} {:keys [modal-type]}]]
   (let [state {:open? true
                :modal-type modal-type}]
     (-> db
         (assoc-in (model/send-to-screening-modal-state-full-path card-state-path) state)))))

(rf/reg-event-db
 ::close-send-to-screening-modal
 [rf/trim-v]
 (fn [db [{:keys [card-state-path]}]]
   (-> db
       (p/dissoc-in (model/send-to-screening-modal-state-full-path card-state-path)))))

(rf/reg-event-db
 ::set-screening-method
 [rf/trim-v]
 (fn [db [{:keys [card-state-path]} screening-method]]
   (-> db
       (assoc-in (conj (model/send-to-screening-modal-state-full-path card-state-path) :screening-method) screening-method))))

(rf/reg-event-fx
 ::send-to-one-time-screening-success
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [card-state-path] :as ctx} _resp]]
   {:db (p/dissoc-in db (model/sending-to-screening-full-path card-state-path))
    :fx [[:dispatch [::common-event/fetch-card-data ctx]]
         [:dispatch [::close-send-to-screening-modal ctx]]]}))

(rf/reg-event-fx
 ::send-to-one-time-screening-error
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [card-state-path] :as ctx} resp]]
   (js/console.log "Send to onetime screening error " resp)
   {:db (p/dissoc-in db (model/sending-to-screening-full-path card-state-path))
    :fx [[:dispatch [::common-event/fetch-card-data ctx]]
         [:dispatch [::close-send-to-screening-modal ctx]]
         [::toast/error (loc/tr :an-error-occurred)]]}))

(rf/reg-event-fx
 ::send-to-one-time-screening
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [entity-id card-state-path] :as ctx} {:keys [persons legal-entities]}]]
   (let [persons (or persons [])
         legal-entities (or legal-entities [])]
     {:db (assoc-in db (model/sending-to-screening-full-path card-state-path) true)
      ::ws/send {:id :screening-profile/submit-data-for-screening
                 :body {:persons persons
                        :legal-entities legal-entities
                        :source :counterparty-diligence
                        :counterparty-diligence-id entity-id}
                 :on-success [::send-to-one-time-screening-success ctx]
                 :on-error [::send-to-one-time-screening-error ctx]}})))

(rf/reg-event-fx
 ::send-to-continuous-screening-success
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [card-state-path] :as ctx} _resp]]
   {:db (p/dissoc-in db (model/sending-to-screening-full-path card-state-path))
    :fx [[:dispatch [::common-event/fetch-card-data ctx]]
         [:dispatch [::close-send-to-screening-modal ctx]]]}))

(rf/reg-event-fx
 ::send-to-continuous-screening-error
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [card-state-path] :as ctx} resp]]
   (js/console.log "Send to continuous screening error " resp)
   {:db (p/dissoc-in db (model/sending-to-screening-full-path card-state-path))
    :fx [[:dispatch [::common-event/fetch-card-data ctx]]
         [:dispatch [::close-send-to-screening-modal ctx]]
         [::toast/error (loc/tr :an-error-occurred)]]}))

(rf/reg-event-fx
 ::submit-send-to-screening-modal
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [card-state-path] :as ctx}]]
   (let [counterparty-diligence (common-model/get-primary-entity db ctx)
         template (cd-template-registry/resolve-template counterparty-diligence)
         counterparty-diligence-id (:db/id counterparty-diligence)

         latest-process (->> counterparty-diligence
                             :counterparty-diligence/processes
                             (mapv #(common-model/get-entity db card-state-path %))
                             (remove nil?)
                             (sort-by :common/created-on)
                             last)
         latest-process-answers (:counterparty-diligence-process/answers latest-process)

         modal-state (get-in db (model/send-to-screening-modal-state-full-path card-state-path))
         {:keys [modal-type screening-method]} modal-state

         selected-legal-entity-ids (get-in db (model/selected-legal-entities-full-path card-state-path) #{})
         selected-natural-person-ids (get-in db (model/selected-natural-persons-full-path card-state-path) #{})]
     (cond
       (and (= modal-type :natural-persons)
            (= screening-method :one-time))
       (let [find-natural-persons-fn (:template/find-natural-persons template)
             all-natural-persons (find-natural-persons-fn {:data latest-process-answers})
             natural-persons-to-send (->> all-natural-persons
                                          (filterv (fn [{:keys [_id]}]
                                                     (contains? selected-natural-person-ids _id))))]

         {:fx [[:dispatch [::send-to-one-time-screening ctx {:persons natural-persons-to-send}]]]})

       (and (= modal-type :natural-persons)
            (= screening-method :continuous))
       {:db (assoc-in db (model/sending-to-screening-full-path card-state-path) true)
        ::ws/send {:id   :counterparty-diligence/copy-people-from-project-to-person-diligence
                   :body {:source-diligence-id counterparty-diligence-id
                          :natural-person-ids  (vec selected-natural-person-ids)
                          :active-screening?   true
                          :instant-screening?  true}
                   :on-success [::send-to-continuous-screening-success ctx]
                   :on-error [::send-to-continuous-screening-error ctx]}}


       (and (= modal-type :legal-entities-and-key-persons)
            (= screening-method :one-time))
       (let [find-legal-entities-fn (:template/find-legal-entities-with-key-persons template)
             all-legal-entities-and-key-persons (find-legal-entities-fn {:data latest-process-answers})

             legal-entities-to-send (->> all-legal-entities-and-key-persons
                                         (filterv (fn [{:keys [_id]}]
                                                    (contains? selected-legal-entity-ids _id))))
             persons-to-send (->> legal-entities-to-send
                                  (mapcat :key-persons)
                                  vec)]
         {:fx [[:dispatch [::send-to-one-time-screening ctx {:persons persons-to-send
                                                             :legal-entities legal-entities-to-send}]]]})

       (and (= modal-type :legal-entities-and-key-persons)
            (= screening-method :continuous))
       {:db (assoc-in db (model/sending-to-screening-full-path card-state-path) true)
        ::ws/send {:id :counterparty-diligence/copy-legal-entities-from-project-to-company-diligence
                   :body {:source-diligence-id counterparty-diligence-id
                          :legal-entity-ids    (vec selected-legal-entity-ids)
                          :active-screening?   true
                          :instant-screening?  true}
                   :on-success [::send-to-continuous-screening-success ctx]
                   :on-error [::send-to-continuous-screening-error ctx]}}))))
